import React from "react";
import "./LoadingCard.scss";

interface IProps {}

const LoadingCard: React.FC<IProps> = () => {
  return <div className="media-card__loading"></div>;
};
export default LoadingCard;
